import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'db-add-template-dialog',
  templateUrl: './questionnaire-add-template-dialog.component.html',
  styleUrls: ['./questionnaire-add-template-dialog.component.scss']
})

export class QuestionnaireAddTemplateDialogComponent implements OnInit {
  addTemplateForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public addTemplateDialogRef: MatDialogRef<QuestionnaireAddTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) { }

  ngOnInit() {
    this.addTemplateForm = this.formBuilder.group({
      templateName: [
        this.data.templateName ? this.data.templateName : '',
        Validators.required
      ]
    });
  }
  submit(form) {
    this.addTemplateDialogRef.close(form.value.templateName);
  }

}
